import { c as _c } from "react/compiler-runtime";
import { CollectionLockup, CollectionLockupContent, CollectionLockupTitle } from "@opensea/app-kit";
import { readFragment } from "@opensea/graphql";
import { Item, ItemContent, ItemDescription, ItemTitle } from "@opensea/next-ui-kit";
import { classNames, FlexCenter, SkeletonBlock, TABLE_SIZES, TextBodySkeleton, Truncate, tableRowSizeVariants, tv } from "@opensea/ui-kit";
import { ItemAvatar } from "@/components/items/avatar/ItemAvatar";
import { ItemPreviewTooltip } from "@/components/items/ItemPreviewTooltip/ItemPreviewTooltip";
import { ExpandedSearch_itemFragment } from "../ExpandedSearch.fragment";
import { useExpandedSearchResultSize } from "./hooks";
const {
  container,
  content
} = tv({
  slots: {
    container: "h-16 border-none p-0",
    content: "w-full"
  }
})();
const randomItemNameWidths = ["w-1/2", "w-1/3", "w-2/5", "w-3/5"];
export const mapItemToSearchResultItem = itemKey => {
  const item = readFragment(ExpandedSearch_itemFragment, itemKey);
  return {
    id: item.id,
    data: itemKey,
    type: "item"
  };
};
export function ExpandedSearchItemResult(t0) {
  const $ = _c(56);
  const {
    item: itemData,
    onSelect,
    className
  } = t0;
  let t1;
  if ($[0] !== itemData.data) {
    t1 = readFragment(ExpandedSearch_itemFragment, itemData.data);
    $[0] = itemData.data;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const item = t1;
  const size = useExpandedSearchResultSize();
  let T0;
  let T1;
  let T2;
  let T3;
  let T4;
  let T5;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[2] !== className || $[3] !== item || $[4] !== onSelect || $[5] !== size) {
    const {
      image,
      text
    } = tableRowSizeVariants({
      size
    });
    T5 = Item;
    if ($[20] !== className) {
      t6 = classNames(container(), "hover:bg-transparent", className);
      $[20] = className;
      $[21] = t6;
    } else {
      t6 = $[21];
    }
    t7 = onSelect;
    t8 = "unstyled";
    const t10 = <ItemAvatar className={classNames(image(), "aspect-square shrink-0")} item={item} size={TABLE_SIZES[size].image} />;
    if ($[22] !== item || $[23] !== t10) {
      t9 = <ItemPreviewTooltip item={item}>{t10}</ItemPreviewTooltip>;
      $[22] = item;
      $[23] = t10;
      $[24] = t9;
    } else {
      t9 = $[24];
    }
    T4 = ItemContent;
    if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
      t5 = content();
      $[25] = t5;
    } else {
      t5 = $[25];
    }
    T3 = ItemPreviewTooltip;
    t4 = item;
    T2 = FlexCenter;
    t3 = "w-full gap-1";
    T1 = Truncate;
    T0 = ItemTitle;
    t2 = classNames(text(), "font-normal");
    $[2] = className;
    $[3] = item;
    $[4] = onSelect;
    $[5] = size;
    $[6] = T0;
    $[7] = T1;
    $[8] = T2;
    $[9] = T3;
    $[10] = T4;
    $[11] = T5;
    $[12] = t2;
    $[13] = t3;
    $[14] = t4;
    $[15] = t5;
    $[16] = t6;
    $[17] = t7;
    $[18] = t8;
    $[19] = t9;
  } else {
    T0 = $[6];
    T1 = $[7];
    T2 = $[8];
    T3 = $[9];
    T4 = $[10];
    T5 = $[11];
    t2 = $[12];
    t3 = $[13];
    t4 = $[14];
    t5 = $[15];
    t6 = $[16];
    t7 = $[17];
    t8 = $[18];
    t9 = $[19];
  }
  let t10;
  if ($[26] !== T0 || $[27] !== item.name || $[28] !== t2) {
    t10 = <T0 className={t2}>{item.name}</T0>;
    $[26] = T0;
    $[27] = item.name;
    $[28] = t2;
    $[29] = t10;
  } else {
    t10 = $[29];
  }
  let t11;
  if ($[30] !== T1 || $[31] !== t10) {
    t11 = <T1>{t10}</T1>;
    $[30] = T1;
    $[31] = t10;
    $[32] = t11;
  } else {
    t11 = $[32];
  }
  let t12;
  if ($[33] !== T2 || $[34] !== t11 || $[35] !== t3) {
    t12 = <T2 className={t3}>{t11}</T2>;
    $[33] = T2;
    $[34] = t11;
    $[35] = t3;
    $[36] = t12;
  } else {
    t12 = $[36];
  }
  let t13;
  if ($[37] !== T3 || $[38] !== t12 || $[39] !== t4) {
    t13 = <T3 item={t4}>{t12}</T3>;
    $[37] = T3;
    $[38] = t12;
    $[39] = t4;
    $[40] = t13;
  } else {
    t13 = $[40];
  }
  let t14;
  if ($[41] !== item.collection || $[42] !== size) {
    t14 = item.collection ? <CollectionLockup collection={item.collection} size={size}><CollectionLockupContent><CollectionLockupTitle className="font-mono" color="text-secondary" disableTextOverflowTooltip={true} /></CollectionLockupContent></CollectionLockup> : null;
    $[41] = item.collection;
    $[42] = size;
    $[43] = t14;
  } else {
    t14 = $[43];
  }
  let t15;
  if ($[44] !== T4 || $[45] !== t13 || $[46] !== t14 || $[47] !== t5) {
    t15 = <T4 className={t5}>{t13}{t14}</T4>;
    $[44] = T4;
    $[45] = t13;
    $[46] = t14;
    $[47] = t5;
    $[48] = t15;
  } else {
    t15 = $[48];
  }
  let t16;
  if ($[49] !== T5 || $[50] !== t15 || $[51] !== t6 || $[52] !== t7 || $[53] !== t8 || $[54] !== t9) {
    t16 = <T5 className={t6} onClick={t7} variant={t8}>{t9}{t15}</T5>;
    $[49] = T5;
    $[50] = t15;
    $[51] = t6;
    $[52] = t7;
    $[53] = t8;
    $[54] = t9;
    $[55] = t16;
  } else {
    t16 = $[55];
  }
  return t16;
}
export function ExpandedSearchItemResultSkeleton(t0) {
  const $ = _c(28);
  const {
    index,
    className
  } = t0;
  const size = useExpandedSearchResultSize();
  let T0;
  let T1;
  let t1;
  let t2;
  if ($[0] !== className || $[1] !== size) {
    const {
      image
    } = tableRowSizeVariants({
      size
    });
    T1 = Item;
    if ($[6] !== className) {
      t2 = classNames(container(), "px-3", className);
      $[6] = className;
      $[7] = t2;
    } else {
      t2 = $[7];
    }
    T0 = SkeletonBlock;
    t1 = classNames(image(), "aspect-square size-auto");
    $[0] = className;
    $[1] = size;
    $[2] = T0;
    $[3] = T1;
    $[4] = t1;
    $[5] = t2;
  } else {
    T0 = $[2];
    T1 = $[3];
    t1 = $[4];
    t2 = $[5];
  }
  let t3;
  if ($[8] !== T0 || $[9] !== t1) {
    t3 = <T0 className={t1} />;
    $[8] = T0;
    $[9] = t1;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  let t4;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = content();
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  const t5 = randomItemNameWidths[index % randomItemNameWidths.length];
  let t6;
  if ($[12] !== t5) {
    t6 = classNames(t5);
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t6) {
    t7 = <FlexCenter className="w-1/2 gap-1"><TextBodySkeleton className={t6} /></FlexCenter>;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  const t8 = randomItemNameWidths[(index + 1) % randomItemNameWidths.length];
  let t9;
  if ($[16] !== t8) {
    t9 = classNames(t8);
    $[16] = t8;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== t9) {
    t10 = <ItemDescription className="w-1/3 max-w-full"><TextBodySkeleton className={t9} /></ItemDescription>;
    $[18] = t9;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== t10 || $[21] !== t7) {
    t11 = <ItemContent className={t4}>{t7}{t10}</ItemContent>;
    $[20] = t10;
    $[21] = t7;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] !== T1 || $[24] !== t11 || $[25] !== t2 || $[26] !== t3) {
    t12 = <T1 className={t2}>{t3}{t11}</T1>;
    $[23] = T1;
    $[24] = t11;
    $[25] = t2;
    $[26] = t3;
    $[27] = t12;
  } else {
    t12 = $[27];
  }
  return t12;
}